import { suppliesCollectionIdFormat } from "@redotech/redo-marketplace-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const deleteSuppliesCollection = unaryRpc({
  name: "deleteSuppliesCollection" as const,
  input: z.object({ id: suppliesCollectionIdFormat.schema }),
  output: z.object({}),
});
